<template>
  <div class="w-full">
    <div
      class="bg-background-neutral-secondary flex flex-col space-y-4 rounded-2xl p-3"
    >
      <div class="flex space-x-3">
        <picture>
          <source
            srcset="@/assets/images/flight-delay-icon.webp"
            type="image/webp"
          />
          <img
            src="@/assets/images/flight-delay-icon.png"
            width="56"
            height="56"
            alt=""
            role="presentation"
          />
        </picture>
        <div class="mb-1 flex w-full flex-1 items-start justify-between">
          <div>
            <p class="text-text-neutral-primary text-base font-semibold">
              {{ flightDelayProducts[0].title }}
            </p>
            <p class="text-text-neutral-secondary text-sm">
              {{ flightDelayProducts[0].short_description }}
            </p>
          </div>
          <button
            type="button"
            @click="
              bottomSheet.show(flightDelayConfig.DESCRIPTION_BOTTOM_SHEET)
            "
          >
            <InfoIcon />
          </button>
        </div>
      </div>
      <FreeButton
        type="button"
        class="w-full"
        size="sm"
        :class="
          bookingStore.flightDelayProducts?.length
            ? 'gray-button'
            : 'green-main-button'
        "
        @click="
          bottomSheet.show(flightDelayConfig.FLIGHT_DELAY_FORM_BOTTOM_SHEET)
        "
      >
        {{
          bookingStore.flightDelayProducts?.length
            ? $t('general.edit')
            : $t('general.add')
        }}
      </FreeButton>
    </div>
    <FlightDelayDescription
      :name="flightDelayConfig.DESCRIPTION_BOTTOM_SHEET"
    />
    <FlightDelayConditions :name="flightDelayConfig.CONDITIONS_BOTTOM_SHEET" />
  </div>
</template>

<script setup lang="ts">
  import { FreeButton } from 'freedom-shared';
  import { controllerModel } from 'shared';

  import {
    flightDelayConfig,
    FlightDelayDescription,
    FlightDelayConditions,
    type FlightDelayProduct,
  } from '@/widgets/flight-delay';

  import { bookingStateModel } from '@/features/booking-state';

  import InfoIcon from '@/assets/images/product-details-icon.svg?component';

  defineProps<{
    flightDelayProducts: FlightDelayProduct[];
  }>();

  defineEmits<{
    onShowFlightDelayInfo: [];
    onProductToggle: [];
  }>();

  const bottomSheet = controllerModel.useBottomSheet();

  const bookingStore = bookingStateModel.useBookingStore();
</script>
